import { supabase } from '../supabase';

/**
 * Registruje novu firmu i njenog vlasnika (SuperAdmin).
 * persistSession: false sprečava automatski login nove firme na trenutnom uređaju.
 */
export const registraAziendaEOwner = async (dati) => {
  try {
    const { data, error } = await supabase.functions.invoke('create-company-admin', {
      body: dati,
    });

    if (error) {
      // Ista logika za hvatanje errora iz Edge funkcije
      let errorDetails = data;
      if (!errorDetails && error.context) {
        errorDetails = typeof error.context.json === 'function' 
          ? await error.context.json() 
          : error.context;
      }
      throw new Error(errorDetails?.error || error.message || "Errore sconosciuto");
    }

    return { success: true, data };
  } catch (err) {
    console.error("ERRORE CREAZIONE AZIENDA:", err);
    throw err;
  }
};


export const registraDipendente = async (dati) => {
  try {
    const { data, error } = await supabase.functions.invoke('invite-worker', {
      body: dati,
    });

    // Supabase baci 'error' ako status nije 2xx
    if (error) {
      // 1. Pokušavamo izvući JSON grešku iz tijela odgovora
      // SDK često stavlja odgovor funkcije unutar error.context
      let errorDetails = data; 
      
      if (!errorDetails && error.context) {
        try {
          // Neke verzije SDK-a zahtijevaju da se context parsira
          errorDetails = typeof error.context.json === 'function' 
            ? await error.context.json() 
            : error.context;
        } catch (e) {
          console.error("Nemoguće parsirati error context", e);
        }
      }

      // 2. Ako je limit dostignut
      if (errorDetails?.error === 'LIMIT_REACHED' || data?.error === 'LIMIT_REACHED') {
        return { 
          success: false, 
          limitReached: true, 
          max: errorDetails?.max || data?.max 
        };
      }

      throw new Error(errorDetails?.error || error.message || "Errore sconosciuto");
    }

    return { success: true };
  } catch (err) {
    console.error("ERRORE INVITO:", err);
    return { success: false, error: err.message };
  }
};


/**
 * Standardni login sa provjerom statusa profila i statusa firme
 */
export const loginUtente = async (email, password) => {
  const { data: authData, error: authErr } = await supabase.auth.signInWithPassword({ email, password });
  if (authErr) throw authErr;

  // 1. Dohvaćamo profil
  const { data: profilo, error: profErr } = await supabase
    .from('profili')
    .select('ruolo, attivo, id_azienda')
    .eq('id', authData.user.id)
    .single();
  if (profErr) throw profErr;

  // 2. Korisnički nalog ugašen?
  if (profilo.attivo === false) {
    await supabase.auth.signOut();
    throw new Error("ACCOUNT_DEACTIVATED");
  }

  // 3. Firma aktivna?
  if (profilo.id_azienda) {
    const { data: azienda, error: azErr } = await supabase
      .from('aziende')
      .select('is_active, plan_type, subscription_end, nome_azienda, admin_name, admin_surname, admin_email, admin_phone')
      .eq('id', profilo.id_azienda)
      .single();

    if (!azErr && azienda && azienda.is_active === false) {

      // Sačuvamo SVE podatke o firmi i korisniku u sessionStorage
      // MORA biti prije signOut-a dok sesija još postoji
      sessionStorage.setItem('inactive_company_data', JSON.stringify({
        ruolo: profilo.ruolo || '',
        id_azienda: profilo.id_azienda,
        plan_type: azienda.plan_type || 'basic',
        subscription_end: azienda.subscription_end || null,
        nome_azienda: azienda.nome_azienda || '',
        admin_name: azienda.admin_name || '',
        admin_surname: azienda.admin_surname || '',
        admin_email: azienda.admin_email || email,
        admin_phone: azienda.admin_phone || '',
      }));

      await supabase.auth.signOut();
      throw new Error("COMPANY_NOT_ACTIVE");
    }
  }

  return { ...authData, ruolo: profilo.ruolo };
};